import { CustomerUsers } from '@src/containers/Dealer/CustomerUsers';
import type { CustomerUsersPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { BlotterPanel } from '../Trading/blotters/BlotterPanel';

export function CustomerUsersPanel({ api, params }: LayoutPanelProps<CustomerUsersPanelConfig>) {
  return (
    <BlotterPanel
      panelApi={api}
      panelTabs={undefined}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-users-panel"
    >
      <CustomerUsers
        layout="panel"
        quickFilterText={params.quickFilterText ?? ''}
        onQuickFilterTextChanged={quickFilterText => api.updateParameters({ quickFilterText })}
      />
    </BlotterPanel>
  );
}
